module.exports = __webpack_public_path__ + "img/bsus.92623d6c.png";